/* ALIVAH — leva o botão "Finalizar compra" direto ao checkout da Yampi.
 *
 * O script oficial da Yampi só age na página /cart (currentPage == 'cart'),
 * então o carrinho lateral não era interceptado e caía no checkout da Shopify.
 * Aqui consultamos o mesmo endpoint que a Yampi usa e redirecionamos.
 * Se a Yampi não responder, o clique cai para /cart (comportamento antigo).
 */
(function () {
  'use strict';

  var ENDPOINT = 'https://api.dooki.com.br/v2/public/shopify/cart';
  var SELETORES = '#CartDrawer-Checkout, #checkout';

  function loja() {
    return (window.Shopify && window.Shopify.shop) || '4f2tgn-vq.myshopify.com';
  }

  function loader(mostrar) {
    var el = document.querySelector('.yampi-loader');
    if (el) el.style.display = mostrar ? 'block' : 'none';
  }

  function comUtms(url) {
    try {
      return typeof ymp_getUrlWithUtms === 'function' ? ymp_getUrlWithUtms(url) : url;
    } catch (e) {
      return url;
    }
  }

  document.addEventListener('click', function (evento) {
    var botao = evento.target && evento.target.closest && evento.target.closest(SELETORES);
    if (!botao) return;

    evento.preventDefault();
    evento.stopPropagation();
    loader(true);

    fetch('/cart.json', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (carrinho) {
        return fetch(ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            // domínio interno: a Yampi só reconhece o domínio próprio depois do DNS ativo
            shop: loja(),
            shopify_internal_domain: loja(),
            cart_payload: carrinho
          })
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (resposta) {
        if (resposta && resposta.active && resposta.checkout_direct_url) {
          window.location.href = comUtms(resposta.checkout_direct_url);
          return;
        }
        throw new Error('checkout da Yampi indisponivel');
      })
      .catch(function () {
        loader(false);
        window.location.href = '/cart';
      });
  }, true);
})();
